import React from 'react';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { activity_palettes } from '../themes';

function SolutionWord({ name, backgroundColor }) {
    return (
        <div
            className='solution-container'
            style={{
                backgroundColor: backgroundColor,
                color: backgroundColor === '#f9f9f9' ? 'black'
                    : backgroundColor === activity_palettes.green.tertiary ? activity_palettes.green.secondary
                        : backgroundColor === activity_palettes.green.error_background ? activity_palettes.green.error_text
                            : 'white'
            }}
        >
            {name}
        </div>
    );
}

export default SolutionWord;
